export const api = process.env.REACT_APP_AWS_API;
